import { render, staticRenderFns } from "./ModalIdentitas.vue?vue&type=template&id=fc2d5ffa&scoped=true&"
import script from "./ModalIdentitas.vue?vue&type=script&lang=js&"
export * from "./ModalIdentitas.vue?vue&type=script&lang=js&"
import style0 from "./ModalIdentitas.vue?vue&type=style&index=0&id=fc2d5ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2d5ffa",
  null
  
)

export default component.exports